import React from 'react';
import { useNavigate } from 'react-router';

const AboutWeSection = ({ themeData }: any) => {
  const navigate = useNavigate();

  return (
    <>
      {' '}
      <section className="trust-section trust-section-home-4">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="trust-content">
                <div className="section-title text-start">
                  <h2
                    className="ps-0"
                    style={{
                      color: `#${themeData?.theme_4?.home?.section_4?.h2color}`,
                    }}
                  >
                    {themeData?.theme_4?.home?.section_4?.title}
                  </h2>
                  <p
                    style={{
                      color: `#${themeData?.theme_4?.home?.section_4?.paracolor}`,
                    }}
                  >
                    {themeData?.theme_4?.home?.section_4?.paragraph_one}
                  </p>
                  <p
                    style={{
                      color: `#${themeData?.theme_4?.home?.section_4?.paracolor}`,
                    }}
                  >
                    {themeData?.theme_4?.home?.section_4?.paragraph_two}
                  </p>
                </div>
                <div className="trust-content-btn d-none">
                  <a
                    href=""
                    onClick={(e) => {
                      e.preventDefault();
                      navigate('/aboutUs');
                    }}
                    className="btn primary-btn hover-btn"
                    style={{
                      background: `#${themeData?.theme_4?.home?.section_4?.btn_group?.btn1?.bg_color}`,
                      color: `#${themeData?.theme_4?.home?.section_4?.btn_group?.btn1?.color}`,
                    }}
                  >
                    {themeData?.theme_4?.home?.section_4?.btn_group?.btn1?.text}
                    <i
                      style={{
                        color: `#${themeData?.theme_4?.home?.section_4?.btn_group?.btn1?.color}`,
                      }}
                      className="uil uil-arrow-right ms-2"
                    ></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="split-abt-list">
                <ul>
                  <li
                    style={{
                      color: `#${themeData?.theme_4?.home?.section_4?.paracolor}`,
                    }}
                  >
                    {themeData?.theme_4?.home?.section_4?.option_one}
                  </li>
                  <li
                    style={{
                      color: `#${themeData?.theme_4?.home?.section_4?.paracolor}`,
                    }}
                  >
                    {themeData?.theme_4?.home?.section_4?.option_two}
                  </li>
                  <li
                    style={{
                      color: `#${themeData?.theme_4?.home?.section_4?.paracolor}`,
                    }}
                  >
                    {themeData?.theme_4?.home?.section_4?.option_three}
                  </li>
                </ul>
                <div className="split-abt-list-img">
                  <img
                    src={themeData?.theme_4?.home?.section_4?.banner}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutWeSection;
